





































import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import SendJobToWorkersRequest from '@/models/JobWorkers/SendJobToWorkersRequest';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { JobDetailsModule } from '@/store/modules/jobDetails';
import JobWorkerSource from '@/models/JobWorkers/JobWorkerSource';
import JobWorkerStatus from '@/models/JobWorkers/JobWorkerStatus';
import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import UpdateJobWorkerStatusWorkerInterestedRequest from '@/models/JobWorkers/UpdateJobWorkerStatusWorkerInterestedRequest';
import JobWorkerSetStatusContactInterested from '@/components/JobWorkers/JobWorkerSetStatusContactInterested.vue'
import JobWorkerSetStatusRejected from '@/components/JobWorkers/JobWorkerSetStatusRejected.vue'
import UpdateJobWorkerStatusInterviewingRequest from '@/models/JobWorkers/UpdateJobWorkerStatusInterviewingRequest';
import UpdateJobWorkerStatusOfferRequest from '@/models/JobWorkers/UpdateJobWorkerStatusOfferRequest';

@Component({
    name: 'JobWorkerSetStatus',
    components: { JobWorkerSetStatusContactInterested, JobWorkerSetStatusRejected }
})
export default class extends GiganautVueDialog {
  
  jobWorkerStatus = JobWorkerStatus;
  menu = false;

  @Prop({required: true})
  jobWorker: JobWorkerDto;

  @Watch('dialog')
  onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
    }
  }

  get loading() {
    return JobDetailsModule.loadingDialog;
  }

  get showWorkerInterested() {
    switch (this.jobWorker.status) {
      case JobWorkerStatus.Shortlisted:
      case JobWorkerStatus.SentToWorker:
      case JobWorkerStatus.WorkerNotInterested:
      case JobWorkerStatus.Rejected: 
        return true;
    }
    return false;
  }

  get showWorkerNotInterested() {
    switch (this.jobWorker.status) {
      case JobWorkerStatus.SentToWorker:
      case JobWorkerStatus.WorkerInterested:
      case JobWorkerStatus.Rejected: 
        return true;
    }
    return false;
  }

  get showContactInterested() {
   switch (this.jobWorker.status) {
      case JobWorkerStatus.SentToContact:
      case JobWorkerStatus.ContactNotInterested:
      case JobWorkerStatus.Rejected: 
        return true;
    }
    return false;
  }

  get showContactNotInterested() {
   switch (this.jobWorker.status) {
      case JobWorkerStatus.SentToContact:
      case JobWorkerStatus.ContactInterested:
      case JobWorkerStatus.Rejected: 
        return true;
    }
    return false;
  }

  get showInterviewOne() {
    switch (this.jobWorker.status) {
      case JobWorkerStatus.Shortlisted:
      case JobWorkerStatus.SentToWorker:
      case JobWorkerStatus.WorkerInterested:
      case JobWorkerStatus.SentToContact:
      case JobWorkerStatus.ContactInterested:
      case JobWorkerStatus.InterviewTwo:
      case JobWorkerStatus.Offer:
      case JobWorkerStatus.Rejected:
        return true;
    }
    return false;
  }

  get showInterviewTwo() {
    switch (this.jobWorker.status) {
      case JobWorkerStatus.InterviewOne:
      case JobWorkerStatus.Offer:
      case JobWorkerStatus.Rejected:
        return true;
    }
    return false;
  }

  get showOffer() {
    switch (this.jobWorker.status) {
      case JobWorkerStatus.Shortlisted:
      case JobWorkerStatus.SentToWorker:
      case JobWorkerStatus.WorkerInterested:
      case JobWorkerStatus.SentToContact:
      case JobWorkerStatus.ContactInterested:
      case JobWorkerStatus.InterviewOne:
      case JobWorkerStatus.InterviewTwo:
        return true;
    }
    return false;
  }

  get showRejected() {
    switch (this.jobWorker.status) {
      case JobWorkerStatus.Shortlisted:
      case JobWorkerStatus.SentToWorker:
      case JobWorkerStatus.WorkerInterested:
      case JobWorkerStatus.SentToContact:
      case JobWorkerStatus.ContactInterested:
      case JobWorkerStatus.InterviewOne:
      case JobWorkerStatus.InterviewTwo:
      case JobWorkerStatus.Offer:
        return true;
    }
    return false;
  }

  async setStatusToWorkerInterested() {  
    const request = new UpdateJobWorkerStatusWorkerInterestedRequest();
    request.jobWorkerId = this.jobWorker.id;
    request.updatedAt = this.jobWorker.updatedAt;
    request.interested = true;
    await JobDetailsModule.updateJobWorkerStatusWorkerInterested(request);
  }

  async setStatusToInterviewOne() {  
    const request = new UpdateJobWorkerStatusInterviewingRequest();
    request.jobWorkerId = this.jobWorker.id;
    request.updatedAt = this.jobWorker.updatedAt;
    request.status = JobWorkerStatus.InterviewOne
    await JobDetailsModule.updateJobWorkerStatusInterviewing(request);
    this.dialog = false;
  }

  async setStatusToInterviewTwo() {  
    const request = new UpdateJobWorkerStatusInterviewingRequest();
    request.jobWorkerId = this.jobWorker.id;
    request.updatedAt = this.jobWorker.updatedAt;
    request.status = JobWorkerStatus.InterviewTwo
    await JobDetailsModule.updateJobWorkerStatusInterviewing(request);
    this.dialog = false;
  }

  async setStatusToOffer() {  
    const request = new UpdateJobWorkerStatusOfferRequest();
    request.jobWorkerId = this.jobWorker.id;
    request.updatedAt = this.jobWorker.updatedAt;
    await JobDetailsModule.updateJobWorkerStatusOffer(request);
    this.dialog = false;
  }
}
